module.exports = __webpack_public_path__ + "static/media/ExpandLessIcon.cd7445fc.svg";